import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

const HypervergeSuccessPopUp = (props) => {
    return (
        <Modal isOpen={props.hypervergeSuccess} centered>
            <ModalHeader toggle={props.toggleHypervergeSuccess} style={{ borderBottom: "none" }}></ModalHeader>
            <img className="mt-3 text-center m-auto" style={{ width: "40px" }} src={process.env.REACT_APP_IMAGES_PATH + "hyperverge_failure.webp"} alt="result-icon" />
            <ModalBody className="succ-body">
                <div className='wrapper text-center m-2'>
                    {props?.errorsHyperverge && props?.errorsHyperverge.length ? <>
                        {/* <h5 className="offline-popup">Oops! Something went wrong. </h5> */}
                        <p className="text-2 offline-popup-small"
                        dangerouslySetInnerHTML={{ __html: props?.errorsHyperverge }} />
                    </> :
                        <> <h5 className="offline-popup">Oops! Something went wrong. </h5>
                            <p className="text-2 offline-popup-small">Connect with us: +91 8591871028 | +91 8928250817 or
                                write to connect@biddeasy.com
                            </p></>}
                       <Button className='mt-2' onClick={props?.reInitiateHyperverge}>Reinitiate KYC</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default HypervergeSuccessPopUp;